import { screenConfig } from "../../utils/fetch";
import axios from "axios";

export const login = (cb) => {
  return async (dispatch) => {
    dispatch({
      type: "LOADING_START",
    });

    const conf = await screenConfig();

    await axios
      .post(`${conf.baseUrl}/auth/signin`, {
        email: conf.email,
        password: conf.password,
      })
      .then((res) => {
        dispatch({
          type: "LOGIN",
          payload: { accessToken: res.data.accessToken, config: conf },
        });
        cb();
      })
      .catch((err) => {
        console.log(err);
      });

    dispatch({
      type: "LOADING_FINISH",
    });
  };
};
